import Vue from 'vue'
import Toasted from 'vue-toasted'

Vue.use(Toasted,{
    theme: "bubble",
    position: "top-center",
    iconPack: 'fontawesome',
    duration: 3500
})

Vue.toasted.register(
    'defaultSuccess',
    payload => !payload.msg ? 'Successfully performed operation!' : payload.msg,
    {type: 'success', icon: 'check'}
)

Vue.toasted.register(
    'defaultWarning',
    payload => !payload.msg ? 'Validate the information!' : payload.msg,
    {type: 'warning', icon: 'exclamation-triangle'}
)

Vue.toasted.register(
    'defaultInfo',
    payload => !payload.msg ? 'Check the information!' : payload.msg,
    {type: 'info', icon: 'exclamation-triangle'}
)

Vue.toasted.register(
    'defaultError',
    payload => !payload.msg ? 'An error has occurred!' : payload.msg,
    {type: 'error', icon: 'times'}
)